
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CharacterBackButton = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/characters");
  };

  return (
    <Button 
      onClick={handleGoBack} 
      variant="outline" 
      size="sm"
      aria-label="Go back to characters list"
    >
      <ArrowLeft className="h-4 w-4 mr-2" aria-hidden="true" />
      Back to Characters
    </Button>
  );
};
